export const SITEIMPROVE_DECLARATIONS = {
  CHANGE_LANGUAGE: {
    id: 'ChangeLanguage',
    actions: {
      CHANGE_TO_NB: 'ChangeToNb',
      CHANGE_TO_NN: 'ChangeToNn',
      CHANGE_TO_EN: 'ChangeToEn',
    },
  },
  HELP_AND_SUPPORT_PAGE_VIEW: {
    id: 'HELP_AND_SUPPORT_PAGE_VIEW',
  },
  FORWARDOPPORTUNITY: {
    id: 'ForwardOpportunity',
    actions: {
      REFERRAL_SEND_ATTEMPT: 'ReferralSentAttempt',
      REFERRAL_SEND_SUCCESS: 'ReferralSuccessfullySent',
      REFERRAL_SEND_FAILURE: 'ReferralFailedToSend',
    },
  },
  HISTORY: {
    id: 'History',
    actions: {
      READ_REPLY: 'ReadReply',
    },
  },
  ONBOARDING: {
    id: 'Onboarding',
  },
  OPEN_HELP_MENU: {
    id: 'OPEN_HELP_MENU',
  },
  OPEN_HELP_MENU_DRAWER: {
    id: 'OPEN_HELP_MENU_DRAWER',
  },
  OPPORTUNITY_ADD: {
    id: 'OPPORTUNITY_ADD',
    actions: {
      READ_MORE: 'ReadMore',
      CREATED: 'Created',
      OPEN: 'OPEN',
    },
  },
  OPPORTUNITY_ARCHIVING: {
    id: 'OPPORTUNITY_ARCHIVING',
    actions: {
      OLD: 'old',
    },
  },
  OPPORTUNITY_HEADER: {
    id: 'OPPORTUNITY_HEADER',
    actions: { FOLLOW_UP_LATER: 'FOLLOW_UP_LATER', ARCHIVE: 'ARCHIVE', REOPEN: 'REOPEN' },
  },
  NEW_OPPORTUNITIES: {
    id: 'NEW_OPPORTUNITIES',
    actions: {
      BANNER: 'BANNER',
    },
  },
  FRONT_PAGE: {
    id: 'FRONT_PAGE',
    actions: {
      ALERT_NEW_OPPORTUNITIES: 'ALERT_NEW_OPPORTUNITIES',
      ALERT_UPDATE_PROFILE: 'ALERT_UPDATE_PROFILE',
      ALERT_ADD_SERVICES: 'ALERT_ADD_SERVICES',
      RELEASE_NOTES_MARK_USEFUL: 'RELEASE_NOTES_MARK_USEFUL',
      RELEASE_NOTES_SEE_ALL: 'RELEASE_NOTES_SEE_ALL',
      DEADLINE_OPEN: 'DEADLINE_OPEN',
      DEADLINE_SEE_ALL: 'DEADLINE_SEE_ALL',
      COUNTY_ACTOR_OPEN: 'COUNTY_ACTOR_OPEN',
      SIVA_COMMENT_OPEN_FEEDBACK: 'SIVA_COMMENT_OPEN_FEEDBACK',
      SIVA_COMMENT_OPEN_APPROVED: 'SIVA_COMMENT_OPEN_APPROVED',
      CLUSTER_STATISTICS_SEE_MORE: 'CLUSTER_STATISTICS_SEE_MORE',
      TASK_OPEN_HALF_YEAR_REPORT: 'TASK_OPEN_HALF_YEAR_REPORT',
      TASK_OPEN_ANNUAL_REPORT: 'TASK_OPEN_ANNUAL_REPORT',
      TASK_OPEN_FINAL_REPORT: 'TASK_OPEN_FINAL_REPORT',
    },
  },
  CLUSTER_CHOOSER: {
    id: 'ClusterChooser',
    actions: {
      selected: (clusterId) => `SelectedCluster_${clusterId}`,
    },
    labels: {
      HEADER: 'HEADER',
    },
  },
  ADD_SERVICE: {
    id: 'AddService',
    actions: {
      FROM_TEMPLATE: 'FromTemplate',
      EMPTY_FORM: 'EmptyForm',
    },
  },
  OPPORTUNITY_BOARD: {
    id: 'OPPORTUNITY_BOARD',
    actions: {
      OPEN_RECOMMEND_SERVICES_MODAL: 'OPEN_RECOMMEND_SERVICES_MODAL',
      SEND_RECOMMENDATION: 'SEND_RECOMMENDATION',
      OPEN_DELIVER_SERVICES_MODAL: 'OPEN_DELIVER_SERVICES_MODAL',
      SEND_DELIVERY: 'SEND_DELIVERY',
      OPEN_ASSIGN_ADVISOR_MODAL: 'OPEN_ASSIGN_ADVISOR_MODAL',
      ASSIGN_ADVISOR: 'ASSIGN_ADVISOR',
    },
    labels: {
      SUCCESS: 'SUCCESS',
      ERROR: 'ERROR',
    },
  },
  OPPORTUNITY_TABLE: {
    id: 'OPPORTUNITY_TABLE',
    actions: {
      OPEN_RECOMMEND_SERVICES_MODAL: 'OPEN_RECOMMEND_SERVICES_MODAL',
      SEND_RECOMMENDATION: 'SEND_RECOMMENDATION',
      OPEN_DELIVER_SERVICES_MODAL: 'OPEN_DELIVER_SERVICES_MODAL',
      SEND_DELIVERY: 'SEND_DELIVERY',
    },
    labels: {
      SUCCESS: 'SUCCESS',
      ERROR: 'ERROR',
    },
  },
  OPPORTUNITY_DETAILS: {
    id: 'OPPORTUNITY_DETAILS',
    actions: {
      OPEN_ASSIGN_ADVISOR_DROPDOWN: 'OPEN_ASSIGN_ADVISOR_DROPDOWN',
      ASSIGN_ADVISOR: 'ASSIGN_ADVISOR',
    },
    labels: {
      SUCCESS: 'SUCCESS',
      ERROR: 'ERROR',
    },
  },
  NAVIGATION: {
    id: 'NAVIGATION',
    labels: {
      SHORTCUT: 'SHORTCUT',
    },
  },
} as const;

export const HOTJAR_DECLARATIONS = {
  UMUX: {
    id: 'UMUX',
    actions: {
      NOTE_ADDED: 'NoteAdded',
      SERVICE_DELIVERED: 'ServiceDelivered',
      SERVICE_RECOMMENDED: 'ServiceRecommended',
      OPPORTUNITY_ARCHIVED: 'OpportunityArchived',
      OPPORTUNITY_FORWARDED: 'OpportunityForwarded',
      OPPORTUNITY_FOLLOWUPLATER: 'OpportunityFollowUpLater',
      OPPORTUNITY_TO_TARGETED: 'OpportunityToTargeted',
      OPPORTUNITY_TO_IDEA: 'OpportunityToIdea',
    },
  },
} as const;
